<template>
  <div :key="key" class="dropdown-button base-button">
    <div v-if="label != ''" class="dropdown">
      <button
        :disabled="disabled"
        :class="`btn btn-${variant} dropdown-icon-button dropdown-toggle`"
        type="button"
        id="dropdownMenuButton1"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <slot name="prepend"> </slot>
        <span class="text-content">{{ label }}</span>
        <slot name="append"> </slot>
      </button>
      <ul
        :class="align == 'left' ? 'dropdown-menu dropdown-custom' : 'dropdown-menu dropdown-custom dropdown-menu-end '"
        aria-labelledby="dropdownMenuButton1"
        style="max-height: 25rem; overflow-x: hidden"
      >
        <li v-for="(item, index) in dropdownList" :key="index">
          <a class="dropdown-item item-custom" @click="$emit('on-click-item', item)">
            <slot :name="`dropdown-${item.title}`">
              <component :key="index" :is="item.icon" v-if="item.icon"></component>
              <a class="text-dropdown-item">{{ item.title }}</a>
            </slot>
          </a>
        </li>
      </ul>
    </div>
    <div v-else class="dropdown">
      <button :disabled="disabled" type="button" class="btn icon-button" data-bs-toggle="dropdown" id="dropdownMenuButton1" aria-expanded="false">
        <slot name="prepend"> </slot>
      </button>
      <ul
        :class="align == 'left' ? 'dropdown-menu dropdown-custom' : 'dropdown-menu dropdown-custom dropdown-menu-end'"
        aria-labelledby="dropdownMenuButton1"
        style="max-height: 25rem; overflow-x: hidden"
      >
        <li v-for="(item, index) in dropdownList" :key="index">
          <a class="dropdown-item item-custom" @click="emits('on-click-item', item)">
            <slot :name="`dropdown-${item.title}`">
              <component :key="index" :is="item.icon" v-if="item.icon"></component>
              <a class="text-dropdown-item">{{ item.title }}</a>
            </slot>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  key?: any;
  tooltipLabel?: string;
  align?: 'left' | 'right';
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'link';
  label?: string;
  disabled?: boolean;
  dropdownList?: Array<{
    title?: string;
    icon?: object;
    value?: string | number;
  }>;
}

const props = withDefaults(defineProps<Props>(), {
  tooltipLabel: '',
  label: '',
  variant: 'primary',
  disabled: false,
  align: 'left',
});

const emits = defineEmits(['on-click-item']);
</script>

<style lang="scss" scoped>
@import '@/assets/styles/base/button.scss';
</style>
